export default __webpack_public_path__ + "a468cb5826617ee2d7b4c550a169614e.png";